import * as z from "zod/v4";

export const uploadCatalogAgentFile = {
  name: "uploadCatalogAgentFile" as const,
  input: z.object({}),
  output: z.object({
    s3Url: z.string(),
    headers: z.array(z.string()),
    sampleRows: z.array(z.record(z.string(), z.string())),
    totalRowCount: z.number(),
  }),
};
